export enum TabletType {
  Time,
  Depth,
}
